// extracted by mini-css-extract-plugin
export var aiStarSpin = "_ml-1";
export var spinner = "_ml-0";